import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../api/api-context';
export const useLogoutApi = (mutationConfig) => {
    const api = useApi();
    const queryClient = useQueryClient();
    const { onSuccess, ...restConfig } = mutationConfig || {};
    const logout = async () => {
        await api.post('/user/logout');
    };
    return useMutation({
        ...restConfig,
        onSuccess: (...args) => {
            queryClient.clear();
            mutationConfig?.onSuccess?.(...args);
        },
        onError: (err, ...args) => {
            queryClient.clear();
            mutationConfig?.onError?.(err, ...args);
        },
        mutationFn: logout,
    });
};
